module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Mostrando "), (_vm.pagination.rows) ? _c('span', [_vm._v(" " + _vm._s(_vm.pagination.rows.length) + " ")]) : _vm._e(), _vm._v(" de " + _vm._s(_vm.pagination.count) + " registro(s)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('label', [_vm._v("Exibir")]), _vm._v(" "), _c('select2', {
    staticStyle: {
      "width": "65px"
    },
    attrs: {
      "options": _vm.sizes
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476ddb9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/table/DWTableHeader.vue
// module id = 857
// module chunks = 1